module.exports = __webpack_public_path__ + "static/img/rank_272.70478c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_272.png
// module id = OWGH
// module chunks = 0